import BaseService from "./BaseService.js";

class ProgramsService extends BaseService {
  get(query) {
    return this.apiGet({
      url: "/tif/program",
      params: query
    });
  }

  getData(query) {
    return this.apiGet({
      url: "/tif/form",
      params: query
    });
  }

  getAnalysis(id) {
    return this.apiGet({
      url: "/tif/program/" + id + "/analysis",
    });
  }

  getOne(id, token) {
    if (token) {
      return this.apiGet({
        url: "/tif/program/" + id,
        headers: {
          Authorization: `Bearer ${token}`,
          'ngrok-skip-browser-warning': true,
        },
      });
    }

    return this.apiGet({
      url: "/tif/program/" + id,
    });
  }

  submit(payload) {
    if (payload.id) {
      const { id, ...data } = payload;
      return this.apiPut({
        url: `/tif/program/${id}`,
        data,
      });
    }
    return this.apiPost({
      url: "/tif/program/",
      data: payload,
    });
  }

  submitForm(id) {
    return this.apiPut({
      url: `/tif/program/submit/${id}`,
    });
  }

  remove(id) {
    return this.apiDelete({
      url: `/tif/program/${id}`,
    });
  }

  accept(id) {
    return this.apiPut({
      url: `/tif/program/${id}/accept`,
    });
  }

  decline(id) {
    return this.apiPut({
      url: `/tif/program/${id}/decline`,
    });
  }
}
const prInstance = new ProgramsService();

export default prInstance;

